import ControlAppSideBar from "@/control/page/ControlAppSideBar/ControlAppSideBar"
import ErrorBoundary from "@/core/error/ErrorBoundary"
import { DiscoPageSkeleton } from "@disco-ui/page/DiscoPage"
import useResizeObserver from "@utils/hook/useResizeObserver"
import React, { Suspense, useRef, useState } from "react"
import classes from "./ControlAppPageLayout.module.css"

export default function ControlAppPageLayout({
  children,
}: {
  children: React.ReactNode
}) {
  // Dynamically handle page content height based on the height of app bars
  const appBarRef = useRef<HTMLElement>()
  const pageBarRef = useRef<HTMLDivElement>(null)
  const [appBarHeight, setAppBarHeight] = useState<number>(
    appBarRef.current?.clientHeight || 0
  )
  const [pageBarHeight, setPageBarHeight] = useState<number>(
    pageBarRef.current?.clientHeight || 0
  )
  useResizeObserver(appBarRef, (el) => setAppBarHeight(el.clientHeight))
  useResizeObserver(pageBarRef, (el) => setPageBarHeight(el.clientHeight))

  return (
    <>
      <div
        className={classes.container}
        style={
          // Define locally-scoped dynamic custom variables for component
          {
            "--app-bar-height": `${appBarHeight}px`,
            "--page-bar-height": `${pageBarHeight}px`,
          } as React.CSSProperties
        }
      >
        {renderSideBars()}
        {renderPage()}
      </div>
    </>
  )

  function renderSideBars() {
    return (
      <nav className={classes.navContainer}>
        <ControlAppSideBar />
      </nav>
    )
  }

  function renderPage() {
    return (
      <div id={"app-page-layout-scroll-container"} className={classes.page}>
        <div className={classes.fullHeightContentContainer}>
          {/* Catch any loading/errors state to keep showing the header/nav elements */}
          <Suspense fallback={<DiscoPageSkeleton />}>
            <ErrorBoundary>{children}</ErrorBoundary>
          </Suspense>
        </div>
      </div>
    )
  }
}
